import React, { useState } from 'react';
import _ from 'lodash';
import Button from 'components/Button';
import VideoDialog from 'components/VideoDialog';
import HeaderTShirt from 'assets/images/header-shirts.png';
import {
  Container,
  Wrapper,
  Img,
  BannerText,
  Links,
  Video,
} from 'styles/pages/home/banner';

const Banner = ({ toggleSignUpDialog, toggleLoginDialog }) => {
  const [videoModalVisibility, setVideoModalVisibility] = useState(false);
  const toggleVideoModalVisibility = () =>
    setVideoModalVisibility(!videoModalVisibility);

  return (
    <Container>
      <Wrapper>
        <img
          src='https://bigoventees.com/img/banner1.png'
          alt='HeaderTShirt'
          style={{ width: '100%' }}
        />
        {/* <Img src='https://bigoventees.com/img/footer.png' alt='HeaderTShirt' />
        <h2>
          Print, Scale, <span>Succeed.</span>
        </h2>
        <Video>
          <Button title='' onClick={() => toggleVideoModalVisibility()} />
          {videoModalVisibility && (
            <VideoDialog
              open={videoModalVisibility}
              toggle={() => toggleVideoModalVisibility()}
              videoId='2dfakNLhu_k'
            />
          )}
        </Video>
        <BannerText>
          <p>Print on demand + drop shipping service.</p>
          <p>We manage automated order production and shipping.</p>
          <p>You focus on selling custom apparel.</p>
        </BannerText>
        <Links>
          <Button
            title='START SELLING'
            onClick={() =>
              _.isFunction(toggleSignUpDialog) && toggleSignUpDialog()
            }
          />

          <Button
            title='ORDER A SAMPLE'
            onClick={() =>
              _.isFunction(toggleLoginDialog) && toggleLoginDialog()
            }
          />
        </Links> */}
      </Wrapper>
    </Container>
  );
};

export default Banner;
